import React from 'react';
import { useNavigate } from 'react-router-dom';
import { TableRowProps } from '@mui/material';
import TableRow from '@mui/material/TableRow';
import { useDataGridFlexSales } from '../DataGridFlexSalesProvider';
import { dateRequestMap } from '../../../helpers';
import routes from '../../../config/routes';
import { ESTIMATED_ROW_HEIGHT } from './columns';

interface RowLinkProps extends TableRowProps {
  row: any;
}

function getFromPath(obj: any, path: string): string {
  return path.split('.').reduce((acc, key) => acc?.[key], obj);
}

const RowLink = React.forwardRef<HTMLTableRowElement, RowLinkProps>(({ row, ...rest }, ref) => {
  const { handler } = useDataGridFlexSales();
  const navigate = useNavigate();

  const handleClick = () => {
    if (!handler.onClickTo) return;

    const clickTo = handler.onClickTo;
    const params = clickTo.paramRows.reduce<Record<string, string>>((acc, key) => {
      const val = row[key];
      acc[key] = val instanceof Date ? dateRequestMap(val) ?? '' : String(val);
      return acc;
    }, {});

    const path = getFromPath(routes, clickTo.pathname);
    navigate(`${path}?${new URLSearchParams(params).toString()}`);
  };

  return (
    <TableRow
      {...rest}
      ref={ref}
      onClick={handler.onClickTo ? handleClick : undefined}
      sx={{
        cursor: handler.onClickTo ? 'pointer' : 'default',
        height: `${ESTIMATED_ROW_HEIGHT}px`,
        ...(rest.sx || {}),
      }}
    />
  );
});

RowLink.displayName = 'RowLink';

export default RowLink;
